export const useSessionStorage = () => {
	const prefix = '@WelbeCompany';

	const setSessionStorage = (key: string, value: string) => {
		sessionStorage.setItem(`${prefix}:${key}`, value);
	};

	const getSessionStorage = (key: string) => {
		return sessionStorage.getItem(`${prefix}:${key}`);
	};

	const removeKeySessionStorage = (key: string) => {
		sessionStorage.removeItem(`${prefix}:${key}`);
	};

	const clearSessionStorage = () => {
		sessionStorage.clear();
	};

	return {
		setSessionStorage,
		getSessionStorage,
		removeKeySessionStorage,
		clearSessionStorage,
	};
};
